import { selectHelplyAccountId } from 'ducks/accounts/selectors/selectHelplyAccountId'
import { selectPrefersHelplyBillingEnforcement } from 'selectors/app/selectAccountPreferences'
import { selectAvailableFeatures } from 'ducks/billing/selectors/selectAvailableFeatures'

// Whether the Groove Copilot panel should be available for this account.
// Entitlement comes solely from the addon-v2-copilot billing addon (the
// ai_enabled preference only gates Groove's internal AI, not paid Copilot).
// Requires a linked Helply account. Staff-managed comps set
// helply_billing_enforcement to false, which bypasses the billing feature
// check; this is not a customer opt-out/toggle. Otherwise require the
// helply_copilot billing feature granted by the addon.

export const selectHasHelplyCopilotAddon = state => {
  if (!selectHelplyAccountId(state)) return false
  if (!selectPrefersHelplyBillingEnforcement(state)) return true

  return selectAvailableFeatures(state)?.helply_copilot === true
}
